module.exports = __webpack_public_path__ + "static/img/EH@2x.3077235c.jpg";